export const formatDateTime = (value: string | null) => {
  if (!value) {
    return null;
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime()) || date.getFullYear() <= 1) {
    return null;
  }
  return date.toLocaleString();
};

export const formatLastSeen = (value: string | null) => {
  if (!value) {
    return "Never connected";
  }
  const formatted = formatDateTime(value);
  return formatted ?? "Unknown";
};
